<p-breadcrumb
  [model]="[
    { label: 'Colaboradores', routerLink: ['/employees'] },
    {
      label: employeeId() ? 'Editar colaborador' : 'Novo colaborador',
      routerLink: employeeId()
        ? ['/employees/update/' + employeeId()]
        : ['/employees/create']
    }
  ]"
  [home]="{ label: '', routerLink: ['/'], icon: 'ph-duotone ph-house text-lg' }"
/>

<form [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="relative">
  <p-toolbar class="mb-5 mt-5">
    <div class="w-full flex flex-wrap justify-between items-center">
      <div>
        @if(employeeId()){
        <h5 class="font-bold">Editar Colaborador</h5>
        <p>Confira e atualize informações</p>
        }@else {
        <h5 class="font-bold">Cadastrar Novo Colaborador</h5>
        <p>Preencha os campos abaixo para cadastrar</p>
        }
      </div>
      <div>
        <div class="flex justify-end gap-5 items-center">
          @if (employeeId()) {
          <div class="flex items-center gap-1">
            <label>Status:</label>
            <p-select
              formControlName="status"
              [options]="statusOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Selecione o status"
              class="w-full"
            ></p-select>
            <app-form-error [control]="formGroup.get('status')" />
            <app-form-server-error [control]="formGroup.get('status')" />
          </div>
          }
          <div class="flex gap-2">
            <p-button
              label="Cancelar"
              routerLink="/employees"
              severity="secondary"
              rounded
              class="btn-secondary-outline"
            >
            </p-button>
            <p-button type="submit" label="Salvar" rounded></p-button>
          </div>
        </div>
        <div>
          @if(formGroup.get('status')?.value != 1) {
          <div class="text-yellow-600 mt-1 flex items-center gap-2">
            <span class="ph ph-warning text-lg"></span>
            Ao definir o status como Desativado ou Bloqueado, o colaborador não
            poderá acessar o sistema.
          </div>
          }
        </div>
      </div>
    </div>
  </p-toolbar>

  <div class="card space-y-5 w-full">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label>Nome *</label>
        <input
          pInputText
          formControlName="firstName"
          class="w-full"
          placeholder="Informe o nome"
        />
        <app-form-error [control]="formGroup.get('firstName')" />
        <app-form-server-error [control]="formGroup.get('firstName')" />
      </div>
      <div>
        <label>Sobrenome *</label>
        <input
          pInputText
          formControlName="lastName"
          class="w-full"
          placeholder="Informe o sobrenome"
        />
        <app-form-error [control]="formGroup.get('lastName')" />
        <app-form-server-error [control]="formGroup.get('lastName')" />
      </div>
    </div>
    <div
      class="grid grid-cols-1 md:grid-cols-2 gap-4"
      [class.md:grid-cols-2]="employeeId()"
    >
      <div>
        <label>E-mail *</label>
        <input
          pInputText
          formControlName="email"
          class="w-full"
          placeholder="nome@beminesplit.com"
        />
        <app-form-error [control]="formGroup.get('email')" />
        <app-form-server-error [control]="formGroup.get('email')" />
      </div>
    </div>
  </div>

  @if (loading()) {
  <div
    class="absolute inset-0 z-30 flex items-center justify-center bg-black/20 backdrop-blur-sm rounded-lg"
  >
    <p-progress-spinner ariaLabel="loading"></p-progress-spinner>
  </div>
  }
</form>

<p-toast />
